export default "__VITE_PUBLIC_ASSET__21695237__"